import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { SubscriptionCards } from "components/SubscriptionModal/SubscriptionCards";
import { Subscription } from "types/Models/subscription";
import {
  SubscriptionEmptyState,
  BookkeepingEmptyState,
} from "components/SubscriptionModal/SubscriptionEmptyState";
import { AddonData } from "store/slices/addons";
import { DiamondPurple } from "components/icons/DiamondPurple";
import { VerticalDivider } from "components/design/VerticalDivider";

export const BooksSubscriptionsDropDown = ({
  booksPlusPlanToshow,
  bookkeepingPlusPlanToShow,
  booksModal,
  onManage,
}: {
  booksPlusPlanToshow: Subscription;
  bookkeepingPlusPlanToShow: Subscription;
  onManage: (addon: AddonData) => void;
  booksModal: (type: string) => void;
}) => {
  return (
    <Dropdown.Root modal={false}>
      <Dropdown.Trigger className="t-border-0" asChild>
        <div className="t-flex t-items-center t-gap-2">
          <div className="t-flex t-items-center t-gap-1 t-cursor-pointer t-text-purple-55 t-text-subtext-sm t-rounded-[3.125rem] t-bg-upgrade-gradient t-p-2">
            <DiamondPurple height={12} width={12} />
            <div className="t-flex t-items-center t-gap-1">
              {booksPlusPlanToshow?.subscription_name ? "Standard" : ""}
              {booksPlusPlanToshow?.subscription_name &&
                bookkeepingPlusPlanToShow?.subscription_name && (
                  <div className="t-flex t-items-center t-justify-center t-w-[0.1875rem] t-text-purple-30 t-h-[0.5625rem] t-overflow-hidden">
                    <div className="t-rounded-md">|</div>
                  </div>
                )}
              {bookkeepingPlusPlanToShow?.subscription_name
                ? bookkeepingPlusPlanToShow?.subscription_name ===
                  "Bookkeeping Monthly +"
                  ? "Monthly+"
                  : "Monthly"
                : ""}
            </div>
          </div>
          <VerticalDivider />
        </div>
      </Dropdown.Trigger>
      <Dropdown.Content align="end" sideOffset={8}>
        <div className="t-p-2 t-flex t-flex-col t-gap-6 t-w-[30rem]">
          {booksPlusPlanToshow ? (
            <SubscriptionCards
              plan={booksPlusPlanToshow.subscription_name}
              features={
                booksPlusPlanToshow.metadata?.comparison?.length
                  ? booksPlusPlanToshow.metadata?.comparison
                  : []
              }
              price={booksPlusPlanToshow.amount}
              billingCycle={
                booksPlusPlanToshow?.billing_cycle! === "MONTHLY"
                  ? "month"
                  : "year"
              }
              title="SOFTWARE SUBSCRIPTION"
              onManage={() => onManage(booksPlusPlanToshow)}
              addon={booksPlusPlanToshow}
            />
          ) : (
            <SubscriptionEmptyState onUpgrade={() => booksModal("Software")} />
          )}
          {bookkeepingPlusPlanToShow?.uuid ? (
            <SubscriptionCards
              plan={bookkeepingPlusPlanToShow?.subscription_name!}
              features={
                bookkeepingPlusPlanToShow?.metadata?.comparison?.length
                  ? bookkeepingPlusPlanToShow?.metadata?.comparison
                  : []
              }
              price={bookkeepingPlusPlanToShow?.amount!}
              billingCycle={
                bookkeepingPlusPlanToShow?.billing_cycle! === "MONTHLY"
                  ? "month"
                  : "year"
              }
              title="BOOKKEEPING SUBSCRIPTION"
              onManage={() => onManage(bookkeepingPlusPlanToShow)}
              addon={bookkeepingPlusPlanToShow}
            />
          ) : (
            <BookkeepingEmptyState onExplore={() => booksModal("Services")} />
          )}
        </div>
      </Dropdown.Content>
    </Dropdown.Root>
  );
};
